import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, importProvidersFrom, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth/auth.interceptor';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';


import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { GlobalErrorHandler } from './utils/error-handler/global-error-handler';

const oktaOptions = {
  issuer: environment.Okta.issuer,
  clientId: environment.Okta.clientId,
  redirectUri: environment.Okta.redirectUri
};

// Create OktaAuth instance
const oktaAuth = new OktaAuth(oktaOptions);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideTranslateService( {
      loader: provideTranslateHttpLoader( {
        prefix: '/assets/i18n/',
        suffix: '.json'
      } ),
      fallbackLang: 'en',
      lang: 'en'
    } ),
    provideZoneChangeDetection( { eventCoalescing: true } ),
    importProvidersFrom(OktaAuthModule),
    importProvidersFrom(HttpClientModule),
    provideRouter(routes),
    { provide: OKTA_CONFIG, useValue: { oktaAuth } },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ]
};
